import React from "react";
import { ModalBody, ModalHeader, ModalFooter, Button, Modal } from "reactstrap";
import ReactTable from "react-table";
import "react-table/react-table.css";
const MembersModal = ({ isOpen, updateProps, reservation }) => {
  const memberRows = reservation.reservation_members || [];

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        updateProps([{ prop: "isMemberModalOpen", value: !isOpen }, { prop: "reservationIndex", value: null }]);
      }}
      className="modal-lg reservations-modal reservations-modal--viewport reservations-modal--members"
    >
      <ModalHeader
        toggle={() => {
          updateProps([{ prop: "isMemberModalOpen", value: !isOpen }, { prop: "reservationIndex", value: null }]);
        }}
      >
        <span className="reservations-modal__title">
          Reservation {reservation.reservation_number} Members List
        </span>
      </ModalHeader>
      <ModalBody className="reservations-modal__body reservations-modal__body--members">
        <div className="reservations-modal__summary">
          <div className="reservations-modal__summary-item">
            <span className="reservations-modal__summary-label">Reservation</span>
            <span className="reservations-modal__summary-value">
              {reservation.reservation_number || "-"}
            </span>
          </div>
          <div className="reservations-modal__summary-item">
            <span className="reservations-modal__summary-label">Guests</span>
            <span className="reservations-modal__summary-value">{memberRows.length}</span>
          </div>
        </div>

        <div className="reservations-modal__table-shell reservations-modal__table-shell--scroll">
        <ReactTable
          data={memberRows}
          columns={[{ Header: "ITS", id: "its", accessor: "its" }, { Header: "Name", id: "name", accessor: "name" }]}
          className="-highlight -striped reservations-table"
          defaultPageSize={10}
          filterable
        />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="secondary"
          onClick={() => {
            updateProps([{ prop: "isMemberModalOpen", value: !isOpen }, { prop: "reservationIndex", value: null }]);
          }}
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default MembersModal;
